import { render, staticRenderFns } from "./PhysicalExams.vue?vue&type=template&id=169f58c6&scoped=true"
import script from "./PhysicalExams.vue?vue&type=script&lang=js"
export * from "./PhysicalExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169f58c6",
  null
  
)

export default component.exports